import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const GradientCTAButton = ({ text }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ width: 'fit-content', borderRadius: '10px', overflow: 'hidden', ml: 1 }}>
      <Button
        onClick={() => navigate('/inspection-booking')}
        sx={{
          width: 'fit-content',
          background: 'linear-gradient(to right, #F1761B, #FF5100)',
          color: '#FFFFFF',
          fontSize: '18px',
          fontWeight: 700,
          borderRadius: '10px',
          py: '10px',
          letterSpacing: '1px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            background: 'linear-gradient(to right, #e0651b, #e94600)',
          },
        }}
      >
        <Typography fontWeight={700} fontSize="12px" px={1}>
          {text}
        </Typography>
      </Button>
      <Box
        sx={{
          height: '15px',
          backgroundColor: '#c5550e',
          mt: '-10px',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
        }}
      />
    </Box>
  );
};

GradientCTAButton.propTypes = {
  text: PropTypes.string.isRequired,
};

export default GradientCTAButton;
